import React from "react";
import { Card } from "@hopper/card";
import { IntegrationStateLabel } from "components/flexible_testing/shared/integration_state_label";
import zephyrScaleIcon from "assets/images/integrations/zephyr-scale.png";
import zephyrSquadIcon from "assets/images/integrations/zephyr-squad.png";

type Integration = {
  key: string;
  name: string;
  active: boolean;
};

type IntegrationCardProps = {
  integration: Integration;
  resetConnection: (integrationKey: string) => void;
  createConnection: (integrationKey: string) => void;
};

type StringMap = {
  [key: string]: string;
};

const iconsMap: StringMap = {
  "zephyr-scale": zephyrScaleIcon,
  "zephyr-squad-legacy": zephyrSquadIcon,
};

const displayIcon = (integrationCode: string) => <img src={iconsMap[integrationCode]} className="mr-sm" />;

const IntegrationCard = ({ integration, createConnection, resetConnection }: IntegrationCardProps) => (
  <div data-test-role="integration" className="w-full mt-3xl">
    <Card active={!!integration.active}>
      <div style={{ height: "144px" }} className="my-lg mx-sm">
        <div className="grid-cols justify-between h-full">
          <div className="mb-md">
            <IntegrationStateLabel isActive={integration.active} />
          </div>
          <div className="flex items-center mb-5xl">
            <div className="ml-md">{displayIcon(integration.key as string)}</div>
            <div data-testid="integration-name" className="text-xl font-bold">
              {integration.name}
            </div>
          </div>
          <div className="ml-md text-sm font-bold cursor-pointer">
            {integration.active ? (
              <span onClick={() => resetConnection(integration.key)}>Reset integration</span>
            ) : (
              <span onClick={() => createConnection(integration.key)}>Create integration</span>
            )}
          </div>
        </div>
      </div>
    </Card>
  </div>
);

export default IntegrationCard;
